import { api } from './api';

const faturaService = {
  list: (params) => api.get('/api/faturas', { params }),
  listOperacional: (competencia, somenteElegiveis = false) =>
    api.get('/api/faturas/operacional', { params: { competencia, somente_elegiveis: somenteElegiveis } }),
  getById: (id) => api.get(`/api/faturas/${id}`),
  gerar: (payload) => api.post('/api/faturas/gerar', payload),
  gerarLote: (payload) => api.post('/api/faturas/gerar-lote', payload),
  enviarLoteAsaas: (payload) => api.post('/api/faturas/enviar-asaas-lote', payload),
  sincronizarAsaas: (payload) => api.post('/api/faturas/sincronizar-asaas', payload),
  atualizarStatusLote: (payload) => api.post('/api/faturas/atualizar-status-lote', payload),
  cancelarAsaas: (payload) => api.post('/api/faturas/cancelar-asaas', payload),
  excluirAsaas: (payload) => api.post('/api/faturas/excluir-asaas', payload),
  excluirLocal: (payload) => api.post('/api/faturas/excluir-local', payload),
  enviarAsaas: (id) => api.post(`/api/faturas/${id}/enviar-asaas`),
  remover: (id) => api.delete(`/api/faturas/${id}`),
};

export default faturaService;
